import MapComponent from "./components/map/MapComponent.jsx";

const App = () => (
  <main>
    <MapComponent />
  </main>
);

export default App;
